export enum Cookie {
  Country = "nf_country",
}
